export const appInfo = {
    title: 'SwimPilot',
  };
  